import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withDebugTracing,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';

import { routes } from './app.routes';
import { TranslateModule } from '@ngx-translate/core';
import { ShellModule } from '@shell/shell.module';
import {
  HTTP_INTERCEPTORS,
  HttpInterceptorFn,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { authInterceptor } from '@core/interceptors';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { JwtInterceptor } from '@auth0/angular-jwt';
import { jwtInterceptor } from '@core/interceptors/jwt.interceptor';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    importProvidersFrom(TranslateModule.forRoot(), ShellModule, NgxPageScrollCoreModule.forRoot()),
    provideHttpClient(
      withInterceptors([authInterceptor])
      //withXsrfConfiguration({cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN'})
    ),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }),
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withPreloading(PreloadAllModules)
      //withDebugTracing() // uncomment this line if you want to see route tracing events
    ),
  ],
};
